import { render, staticRenderFns } from "./formmain.vue?vue&type=template&id=1d4a676e&"
import script from "./formmain.vue?vue&type=script&lang=js&"
export * from "./formmain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports